export const ScoringStatsComponent = {
  bindings: {
    percent: '<',
  },
  templateUrl: 'missions/components/Scoring/scoring-stats/scoring-stats.html',
  controller: function ScoringStatsController() {
    'ngInject';
  },
};
